import { LoadingButton } from '@mui/lab';
import { Box, Tooltip } from '@mui/material';

interface Props {
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
  quantity?: number;
  maxQuantity?: number;
}

// Mobile card variant: full-width text LoadingButton, kept separate from the icon-only
// `AddToCartButton` used by the desktop table / details page / favourites.
export default function AddToCartButtonMobile({
  isDisabled,
  isLoading,
  onClick,
  quantity,
  maxQuantity,
}: Props) {
  const insufficientStock = !!quantity && !!maxQuantity && quantity > maxQuantity;
  const buttonProps = {
    fullWidth: true,
    loading: isLoading,
    variant: 'outlined' as const,
    disabled: isDisabled || insufficientStock,
    onClick,
  };

  if (insufficientStock) {
    return (
      <Tooltip title={`Quantity must be ${maxQuantity} or less`}>
        <Box width="100%">
          <LoadingButton sx={{ fontSize: '13px', color: '#000' }} {...buttonProps}>
            Insufficient Stock
          </LoadingButton>
        </Box>
      </Tooltip>
    );
  }
  return (
    <LoadingButton sx={{ color: '#000' }} {...buttonProps}>
      Add to Basket
    </LoadingButton>
  );
}
